
export default function CoreValues() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Safety First',
      description: 'Every system we deliver is designed to protect life and property.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Reliability',
      description: 'We ensure every installation meets the highest standards of performance.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'We adopt the latest fire safety technologies and best practices.'
    },
    {
      icon: 'ri-handshake-line',
      title: 'Integrity',
      description: 'We value trust and transparency in every client relationship.'
    },
    {
      icon: 'ri-star-line',
      title: 'Excellence',
      description: 'From design to delivery, we aim for perfection in every detail.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Values</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            These principles guide everything we do at FlameGuardQA, ensuring we deliver 
            exceptional fire safety solutions with unwavering commitment.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-2xl hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-full mb-6">
                <i className={`${value.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-gray-700 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-red-50 p-8 rounded-2xl max-w-4xl mx-auto">
            <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-full mx-auto mb-6">
              <i className="ri-fire-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              "At FlameGuardQA, we don't just install systems — we build trust and safety that lasts."
            </h3>
            <p className="text-lg text-gray-700">
              Every project we undertake reflects our commitment to protecting what matters most to you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}